module.exports = __webpack_public_path__ + "img/152.a7c2e5fa.jpg";